import React from "react";
import { Storefront, Users, HandCoins, Compass } from "@phosphor-icons/react";
import ComingSoonShell from "@/components/ComingSoonShell";

export default function MarketplaceComingSoon() {
  return (
    <ComingSoonShell
      testid="coming-soon-marketplace"
      title={<>Marketplace <span className="font-editorial italic">agenti.</span></>}
      intro="Il network B2B più semplice del mercato immobiliare italiano. Trova colleghi con immobili nelle tue zone, condividi mandati e dividi le provvigioni — tutto dentro Pronto, niente Whatsapp che si perdono."
      preview={(
        <div className="flex items-center gap-4">
          <div className="shrink-0 w-24 h-24 rounded-xl border-2 border-[#1C1C1A] bg-[#F1F4ED] inline-flex items-center justify-center">
            <Storefront size={36} weight="duotone" className="text-[#7C8B6E]" />
          </div>
          <div className="flex-1 min-w-0 text-[13px] text-[#3A3A36] leading-relaxed">
            <div className="font-semibold text-[#1C1C1A] mb-1">Più agenti · meno tempo perso</div>
            Pubblichi il tuo mandato come "in collaborazione", filtri per zona e
            categoria, gli altri agenti vedono solo quello che ti serve mostrare.
            Quando c'è un match, parlate direttamente in Pronto.
          </div>
        </div>
      )}
      whyNotYet="Per fare un marketplace di valore servono volumi: serve un numero minimo di agenti attivi su Pronto perché ci sia davvero qualcosa da scambiare nelle tue zone. Stiamo facendo crescere la rete prima, poi attiviamo il marketplace quando ogni zona ha almeno 5-10 agenti attivi. Ti avviseremo non appena la tua zona sarà abbastanza coperta da garantire match veri."
      whatItWillDo={[
        { icon: Compass, label: "Filtri per zona", body: "Vedi solo gli immobili nelle micro-zone OMI che ti interessano. Niente rumore, niente perditempo." },
        { icon: Users, label: "Match privati 1-a-1", body: "Pubblichi 'cerco trilocale Brera fino a €700k per cliente acquirente' → ricevi 3 proposte da colleghi in 24h. Tutto sotto firma digitale." },
        { icon: HandCoins, label: "Spartizione provvigioni", body: "Pronto calcola e traccia la spartizione delle provvigioni in collaborazione (50/50, 60/40, custom). Tutto trasparente, niente carta." },
      ]}
      interestSlug="marketplace"
      interestTitle="Marketplace agenti B2B"
    />
  );
}
